<template>
  <div class="bar-chart-container pt-5 pr-5">
    <Bar
      :chart-options="computedOptions"
      :chart-data="computedChartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="computedPlugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels
);

export default {
  name: "BaseBarChart",
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
    enableDataLabels: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    
    eventData: {
      type: Number,
      default: null,
    },
    
  },

  computed: {
    formattedLabels() {
      const labels = this.chartData.labels || [];
      
      return labels;
    },

    computedChartData() {
      return {
        ...this.chartData,
        labels: this.formattedLabels,
      };
    },

    computedPlugins() {
      return this.enableDataLabels ? [ChartDataLabels] : [];
    },

    computedOptions() {
  const baseOptions = {
    responsive: true,
    maintainAspectRatio: false,

    // 🔥 THIS MAKES THE BAR CHART HORIZONTAL
    indexAxis: 'y',

    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: { size: 14 },
          usePointStyle: true,
          pointStyle: "rect",
          generateLabels: this.generateCustomLabels,
        },
      },
      tooltip: {
    callbacks: {
      label: function (context) {
        const dataset = context.dataset;
        const index = context.dataIndex;

        const value = context.raw;
        const percent = dataset.percent ? dataset.percent[index] : null;

        if (percent !== null) {
          return `${dataset.label}: ${value} (${percent}%)`;
        }

        return `${dataset.label}: ${value}`;
      }
    }
  },
      datalabels: this.enableDataLabels
        ? {
            display: true,
            anchor: "end",
            align: "right",
            color: "#000",
            font: { size: 12 },
            formatter: (value, context) => {
  const dataset = context.dataset;
  const index = context.dataIndex;

  const percent = dataset.percent 
    ? dataset.percent[index] 
    : null;

  if (percent !== null) {
    return `${value} (${percent}%)`;
  }

  return value;
}

          }
        : { display: false },
    },

    scales: {
      x: {
        stacked: this.stacked,
        beginAtZero: true,
        grid: { display: false },
        ticks: { font: { size: 11 } },
        grace: '20%',
      },
      y: {
        stacked: this.stacked,
        grid: { display: false },
        ticks: {
          autoSkip: false,
          font: { size: 12 },
        },
      },
    },
  };

  return { ...baseOptions, ...this.chartOptions };
}

  },

  methods: {
    generateCustomLabels(chart) {
      const datasets = chart.data.datasets;
      
      return datasets.map((dataset, i) => {

        return {
          text: dataset.label,
          fillStyle: dataset.backgroundColor,
          strokeStyle: dataset.backgroundColor,
          lineWidth: 2,
          hidden: false,
          index: i,
          pointStyle: 'rect'
        };
      });
    },

    forceChartUpdate() {
      this.$forceUpdate();
    }
  },

  watch: {
    chartData: {
      deep: true,
      handler() {
        this.forceChartUpdate();
      },
    },
    chartOptions: {
      deep: true,
      handler() {
        this.forceChartUpdate();
      },
    },
    
    eventData() {
      this.forceChartUpdate();
    },
    activeTab() {
      this.forceChartUpdate();
    }
  },
};
</script>

<style scoped>
.bar-chart-container {
    
  > div {
    min-height: 700px;
  }
  canvas {
    height: 600px !important;
  }
  width: 100%;

  max-width: 100%;
  position: relative;
}

</style>